import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import getTestId from '../../../../../../tests/utils/get-test-id';
import { ToolStatus } from '../../../../types/tool.types';
import ToolArgumentsSection from '../../shared/ToolArgumentsSection';
import ToolJsonResultSection from '../../shared/ToolJsonResultSection';
import { ToolContent } from '../../styles';
import ToolSQLRenderer from './index';
const SQLToolBodyRenderer = ({ model, expandedSections, setExpandedSections, }) => {
    if (model.app !== 'admin') {
        return null;
    }
    return (_jsxs(ToolContent, Object.assign({}, getTestId('assistant-tool-content'), { children: [_jsx(ToolArgumentsSection, { tool: model.tool, expandedSections: expandedSections, setExpandedSections: setExpandedSections }), (model.status === ToolStatus.SUCCESS ||
                model.status === ToolStatus.PARTIAL) && (_jsx(ToolSQLRenderer, { tool: model.tool, toolName: model.toolName })), model.status === ToolStatus.FAILURE && (_jsx(ToolJsonResultSection, { tool: model.tool, status: model.status, expandedSections: expandedSections, setExpandedSections: setExpandedSections }))] })));
};
export default SQLToolBodyRenderer;
